import React, { useState } from 'react';
import { goToTop } from '_helpers';
import styled from 'styled-components';
import { _ } from '_locales';
import FLCarousel from './components/FLCarousel';
import FLDetails from './components/FLDetails';
import { Arrow } from '../../../styles/common-styles';

const FeaturedLessons = ({
  setDisplayedContent, setRef, windowsWidth, campaignUrl, featured_lessons
}) => {
  const flData = [].concat(...featured_lessons).map((i) => ({ ...i, coachables: i.activities }));
  const [flIndex, setFlIndex] = useState(0);
  const [showFlDetails, setShowFlDetails] = useState();

  const openFlHandler = () => {
    setShowFlDetails(true);
    setDisplayedContent('featuredLessons');
    goToTop();
  };

  const nextFLHandler = () => {
    setFlIndex((prevState) => prevState + 1);
    goToTop();
  };

  const goBackHandler = () => {
    setShowFlDetails(false);
    setDisplayedContent();
    goToTop();
    setRef('FLRef');
  };

  const prevoiousFLHandler = () => {
    setFlIndex((prevState) => prevState - 1);
    goToTop();
  };

  return (
    <Container>
      <Title>
        {showFlDetails && (
          <Arrow background="#fff" onClick={goBackHandler} aria-label="Go back">
            &#8678;
          </Arrow>
        )}
        {showFlDetails
          ? flData[flIndex].campaign_nm : _('education.featured_lesson')}
      </Title>

      {showFlDetails ? (
        <FLDetails
          featured_lessons={flData}
          flIndex={flIndex}
          goBackHandler={goBackHandler}
          key={flIndex}
          prevoiousFLHandler={prevoiousFLHandler}
          nextFLHandler={nextFLHandler}
          campaignUrl={campaignUrl}
        />
      ) : (
        <FLCarousel
          flIndex={flIndex}
          featured_lessons={flData}
          openFlHandler={openFlHandler}
          windowsWidth={windowsWidth}
          setFlIndex={setFlIndex}
        />
      )}
    </Container>
  );
};

export default FeaturedLessons;

const Container = styled.div`
  box-sizing: border-box;
  padding: 10px 0;
  padding-top: 5px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  overflow: hidden;
  position: relative;
`;

const Title = styled.h2`
  display:flex;
  align-items: center;
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: 700 !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  margin-top: 10px !important;
`;
